import Loadable from '../../components/loadable';

const TasksList = Loadable({
  loader: () => import('../../pages/tasks/tasks_list'),
});

angular.module('gym').value('TasksList', TasksList);
